import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    body {
        margin: 0;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
            'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
            'Helvetica Neue', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        background-color: ${({ theme }) => theme.palette.background.background};
        color: ${({ theme }) => theme.palette.text.primary};
    }

    ::-webkit-scrollbar {
        width: 8px;
        height: 3px;
    }

    ::-webkit-scrollbar-track {
        background-color: #646464;
    }
    
    ::-webkit-scrollbar-track-piece {
        background-color: #000;
    }
    
    ::-webkit-scrollbar-thumb {
        height: 0;
        background-color: #666;
        border-radius: 3px;
    }
    
    ::-webkit-scrollbar-corner {
        background-color: #646464;
    }
    
    ::-webkit-resizer {
        background-color: #666;
    }

    .MuiAppBar-root {
        background-color: ${({ theme }) =>
            theme.palette.background.background} !important;
    }

    .MuiCheckbox-root {
        color: white !important;
    }

    .Mui-checked {
        color: white !important;
    }

    .MuiDrawer-paper {
        background-color: ${({ theme }) =>
            theme.palette.background.default} !important;
    }

    .MuiFormControlLabel-label {
        font-size: 0.9rem !important;
    }

    .MuiDialog-paper {
        background-color: ${({ theme }) =>
            theme.palette.background.background} !important;
        color: ${({ theme }) => theme.palette.text.primary} !important;
    }

    .MuiDialogContentText-root{
        color: ${({ theme }) => theme.palette.text.primary} !important;
    }
`;

export default GlobalStyle;
